import React, { useEffect, useState } from 'react';
import TableB from 'react-bootstrap/Table';

function Table({ source }) {

    const [list,setList] = useState([]);

    useEffect(()=>{
      if(source !== undefined){
        setList(()=> source);
      }
        
    },[source])

  return (
    <TableB striped bordered hover>
    <thead>
      <tr>
        <th style={{width:"170px"}}>Fecha</th>
        <th>Actividad</th>
        {/* <th>Link</th> */}
        
      </tr>
    </thead>
    <tbody>
        {
            list.map((item,index) =>{
                return (<tr key={index}>
                  <td>{ new Date(item.createdAt).toLocaleString() }</td>
                  <td>{ item.description }</td>
                  {/* <td className='text-break'>
                    <a href={item.action} rel='noreferrer' target='_blank'>Abrir Link</a>
                  </td> */}
                </tr>);
            })
        }
    </tbody>
  </TableB>
  )
}

export default Table